var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testing flex start-v",style:({backgroundColor: 'rgba(255, 246, 233, 1)'})},[_c('RemnCard',{directives:[{name:"show",rawName:"v-show",value:(!_vm.done),expression:"!done"}],ref:"testcard",attrs:{"questionList":_vm.questionList},on:{"questionDone":function($event){_vm.done=true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }